import { z } from 'zod';
import { TaskPriority } from './project.js';
/**
 * Phân loại nhanh lúc tạo task — APM-AI-h (`plan-ai-features.md` mục 2).
 *
 * ## Hai nửa, và nửa nào chạy khi không có AI
 *
 * `duplicates` và `storyPointsHint` là **tất định**: FULLTEXT tính điểm giống
 * nhau, thống kê tính điểm story tham chiếu. Chúng không cần model, nên form
 * tạo task vẫn hiện chúng khi tổ chức chưa có key AI — đó là điều kiện của
 * ADR-006 chứ không phải một tiện nghi.
 *
 * `ai` là nửa còn lại: chọn loại việc, mức ưu tiên, người làm, và **giải thích**.
 * `null` khi chưa cấu hình AI hoặc lượt chạy hỏng; form bỏ qua nó và phần tất
 * định vẫn ở đó.
 */
export const TriageDuplicate = z.object({
    taskId: z.uuid(),
    key: z.string(),
    title: z.string(),
    statusCategory: z.string().nullable(),
    /**
     * Độ giống **tương đối trong tập kết quả này** (0–1), không phải xác suất.
     *
     * Điểm của `MATCH … AGAINST` là một số không có trần, chỉ so được với nhau
     * trong cùng một truy vấn. Chia cho điểm cao nhất cho ra thứ đọc được ("cái
     * này giống nhất"), và **không** cho ra "87% khả năng trùng" — đừng hiển thị
     * nó như một xác suất.
     */
    similarity: z.number().min(0).max(1),
});
export const TriageStoryPoints = z.object({
    /** Trung vị điểm story của những task tương tự **đã xong**. */
    value: z.number().positive(),
    low: z.number().positive(),
    high: z.number().positive(),
    /** Bao nhiêu task đã xong góp vào con số này. Ít thì đừng tin nhiều. */
    sampleSize: z.number().int().positive(),
});
export const TriageSuggestion = z.object({
    taskTypeId: z.uuid().nullable(),
    priority: TaskPriority.nullable(),
    assignee: z
        .object({
        userId: z.uuid(),
        reason: z.string().min(1).max(300),
        alternatives: z.array(z.object({ userId: z.uuid(), reason: z.string().max(300) })).max(3),
    })
        .nullable(),
    /** Vì sao chọn như vậy — một câu, hiện ngay cạnh dải gợi ý. */
    reason: z.string().min(1).max(500),
});
export const TaskTriage = z.object({
    duplicates: z.array(TriageDuplicate).max(5),
    storyPointsHint: TriageStoryPoints.nullable(),
    ai: TriageSuggestion.nullable(),
    /** Vì sao `ai` rỗng — `no_key`, `failed`, hoặc `null` khi có kết quả. */
    aiSkipped: z.enum(['no_key', 'failed']).nullable(),
});
export const TaskTriageInput = z.object({
    title: z.string().min(3).max(500),
    description: z.string().max(5_000).optional(),
    /** Bỏ qua phần AI và chỉ lấy phần tất định — form gọi vậy khi người dùng đang gõ. */
    deterministicOnly: z.boolean().optional(),
    runId: z.uuid().optional(),
});
//# sourceMappingURL=ai-triage.js.map